import { render, staticRenderFns } from "./correct-rate-round.vue?vue&type=template&id=5e527b86&scoped=true"
import script from "./correct-rate-round.vue?vue&type=script&lang=js"
export * from "./correct-rate-round.vue?vue&type=script&lang=js"
import style0 from "./correct-rate-round.vue?vue&type=style&index=0&id=5e527b86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e527b86",
  null
  
)

export default component.exports